




























































import Vue from "vue";
import Component from "vue-class-component";
import { LLayerGroup } from "vue2-leaflet";
import AisTarget from "./AisTarget.vue";
import bboxFilter from "@/utils/bbox_filter";

import { icon, latLng } from "leaflet";
import { IVessel } from "@/store/targets/models";
import { targets, maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

import { LCircleMarker } from "vue2-leaflet";

//import { Grupo } from "@/store/grupos/models";
import { grupos } from "@/store";


const aisIcon = require("../../../assets/icons/ais/ais-target-heading-n.svg");
const aisIconL = require("../../../assets/icons/ais/ais-target-heading-l.svg");
const aisIconC = require("../../../assets/icons/ais/ais-target-heading-c.svg");
const aisIconR = require("../../../assets/icons/ais/ais-target-heading-r.svg");

@Component({
  components: {
    LLayerGroup,
    AisTarget,
    LCircleMarker,
  },
})
export default class Vessels extends Vue {
  timer: number = 0;

  //Iconos AIS
  aisIcon = "@/assets/icons/ais/ais-target-heading-n.svg";
  aisIconC = "@/assets/icons/ais/ais-target-heading-c.svg";
  aisIconR = "@/assets/icons/ais/ais-target-heading-r.svg";
  aisIconL = "@/assets/icons/ais/ais-target-heading-l.svg";

  //methods
  mounted() {
    grupos.actions.fetchGrupos();
  }

  coordsBuilder(vessel: IVessel) {
    const lon = vessel.position.coordinates[0];
    const lat = vessel.position.coordinates[1];
    return latLng(lat, lon);
  }
  vesselInfo(vessel: IVessel) {
    return {
      mmsi: vessel.mmsi,
      name: vessel.statics.name,
      callsign: vessel.statics.callsign,
      destination: vessel.statics.destination,
    };
  }
  iconSelector(vessel: IVessel) {
    let icono = aisIcon;
    if (vessel.heading < 511) {
      if (vessel.speed > 1) {
        if (vessel.turn > 0) {
          icono = aisIconR;
        } else if (vessel.turn < 0) {
          icono = aisIconL;
        } else {
          icono = aisIconC;
        }
      } else {
        icono = aisIconC;
      }
    }
    return icon({
      iconUrl: icono,
      iconSize: [70, 70],
    });
  }
  clickHandler(mmsi: number) {
    if (maps.getters.measurementActivated) {
      maps.commit(MutationTypes.ADD_MEASUREMENT_POINT, {
        tipo: "vessel",
        data: mmsi,
      });
    }
  }
  //computed
  get vesselList() {
    return targets.getters.vesselList;
  }
  get selectedVessel() {
    return targets.getters.selectedVessel;
  }
  get filteredVessels() {
    //return bboxFilter(this.vesselList, "position");
    const filtered = bboxFilter(this.vesselList, "position");
    
    //grupos.actions.fetchGrupos();
    
    const grupos_all = grupos.getters.grupos;
    
    for (const blanco of filtered) {      
      for(const grupo of grupos_all){
        if(blanco.mmsi in grupo.blancos){
          blanco.colorHex = grupo.color;
          break;
        }
      }
    }
    
    return filtered;
  }

  getColorAndOpacity(hex: string) {
    if(hex === undefined){
      return "#00000000";
    }else{
          
      if (hex.length === 9) {
        // #AARRGGBB → separar
        const a = hex.slice(1, 3)
        const r = hex.slice(3, 5)
        const g = hex.slice(5, 7)
        const b = hex.slice(7, 9)

        const alpha = parseInt(a, 16) / 255

        return `rgba(${parseInt(r,16)}, ${parseInt(g,16)}, ${parseInt(b,16)}, ${alpha})`
      }
    }
  }

}
